import HttpClient from './HttpClient'
import Lang from './Lang'
import ModuleNavigation from './ModuleNavigation'
import Swal from 'sweetalert2'

export default class GamifiedVideoHandler {
    #url
    #httpClient

    constructor(element) {
        this.#url = element.dataset.gpUrl
        this.#httpClient = new HttpClient()

        this.#bindEvents()

        ModuleNavigation.disableNavigation()
    }

    static init(selector) {
        Array.from(
            document.querySelectorAll(selector),
            (element) => new GamifiedVideoHandler(element)
        )
    }

    #bindEvents() {
        window.addEventListener('message', this.#started, false)
    }

    #started = (event) => {
        let eventData = JSON.parse(event.data)
        if (!eventData.triggerName || eventData.triggerName !== 'hihaho_started') {
            return
        }

        let videoId = eventData.triggerData.video_id
        let sessionId = eventData.triggerData.session_id

        this.#httpClient
            .post(this.#url, {
                extra_data: {
                    session_id: sessionId,
                    video_id: videoId,
                },
            })
            .then(function (response) {
                ModuleNavigation.enableNavigation()
            })
            .catch(function (error) {
                ModuleNavigation.enableNavigation()

                Swal.fire({
                    icon: 'error',
                    title: Lang.get('general.oops'),
                    text: Lang.get('gamified_video.unable_to_retrieve_progress'),
                })
            })
    }
}
